import React from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Image } from "antd-mobile";
import useCustomTranslation from "@/hooks/useTranslation";

const SortBy: React.FC<{
	data: any[];
	onVisiblePopup: (visible: boolean) => void;
	onSubmit: (index: number) => void;
}> = ({ data, onVisiblePopup, onSubmit }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	return (
		<div className={classes.manageNumbers}>
			<header>
				<div
					className="closeIcon"
					onClick={() => {
						onVisiblePopup(false);
					}}
				>
					<Image
						src={require("@/assets/images/icons/back.png")}
						width={20}
						height={18}
					/>
				</div>
				<p>{t("SortBy")}</p>
			</header>
			<ul>
				{data.map((item, index) => {
					return (
						<li onClick={() => onSubmit(index)} key={index}>
							<p>{t(item.name)}</p>
						</li>
					);
				})}
			</ul>

			<div
				onClick={() => {
					onVisiblePopup(false);
				}}
				className="cancel"
			>
				<span>{t("Cancel")}</span>
			</div>
		</div>
	);
};

export default SortBy;

const useStyles = createUseStyles({
	manageNumbers: {
		display: "flex",
		flexDirection: "column",
		borderTopLeftRadius: pxToRem(10),
		borderTopRightRadius: pxToRem(10),
		backgroundColor: "#1E212A",
		"& header": {
			position: "relative",
			height: pxToRem(58),
			lineHeight: pxToRem(58),
			textAlign: "center",
			fontSize: pxToRem(15),
			color: "#FFFFFF",
			borderBottom: "1px solid #2F3A62",
			"& .closeIcon": {
				position: "absolute",
				top: "50%",
				left: pxToRem(15),
				transform: "translateY(-50%)",
			},
			"& .determine": {
				position: "absolute",
				top: "50%",
				right: pxToRem(14),
				color: "#4B6DE3",
				transform: "translateY(-50%)",
			},
		},
		"& ul": {
			flex: 1,
			overflowY: "auto",
			"& >li": {
				height: pxToRem(68),
				display: "flex",
				alignItems: "center",
				padding: {
					left: pxToRem(20),
					right: pxToRem(30),
				},
				justifyContent: "space-between",
				borderBottom: "1px solid #2F3A62",
				"& p": {
					flex: 1,
					fontSize: pxToRem(14),
					fontWeight: "400",
					color: "#FFFFFF",
					overflow: "hidden",
				},
			},
		},
		"& .cancel": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: pxToRem(88),
			color: "#FF6161",
			fontSize: pxToRem(18),
			fontWeight: "500",
		},
	},
});
